import { combineEpics, ofType } from "redux-observable";
import { EMPTY, from, map, mergeMap, of, switchMap, withLatestFrom } from "rxjs";
import { RootState } from "../../../store/ConfigureStore";
import { CallNewTDH, getDepletionCurveData, GetDepletionPercentage, GetFutureBHP, getIPRGraphData, getIPRTableData, getTDHData, getTailPipeTZ } from "../../../services/calculations/calculation-output/basicCalculation.service";
import { setBasicCalculationComplete, setBasicIPRMethodologySelection, setBasicNewTDH, setBasicTDHCalculationOutput, setBasicWellInflowData, setBasicWellIPRDepletionPercentage, setBasicWellIPRFutureBHP, setDepletionChartData, setIPRChartData } from "../../../store/calculation/calculation-output/basicCalculationSlice";
import { BasicTDHCalculation, DepletionPercentageInObject, FutureBHPInObject, IPR } from "../../../store/model/calculations/calculation";

const getWellInflowData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/setGasCalculationComplete"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationComplete))
        ),
        switchMap(([actionData, tab1Input, tab2Input, tab3Input, gasCalculationComplete]) => {

            if (gasCalculationComplete && tab3Input?.combinedSpGr !== "NaN") {
                const bubblePoint = tab3Input?.bubblePoint;
                const bubblePresUnit = tab3Input?.unitBubblePointListVal;
                const combinedspGr = tab3Input?.combinedSpGr;
                const inflowType = +(tab2Input?.inflowTypeLstVal) || 0;
                let flowRate = null;
                let flowingBHHd = null;
                let flowingBHPressure = null;
                let piValue = null;
                let staticBHHd = null;
                let staticBHPressure = null;
                const piUnit = tab2Input?.unitPIValListVal;

                if (inflowType === 0) {
                    piValue = tab2Input?.piVal?.toString();
                    staticBHPressure = tab2Input?.reservoirPressure?.toString();
                    staticBHHd = tab2Input?.staticFluidLvl?.toString();
                }
                if (inflowType === 1) {
                    flowRate = tab2Input?.flowRate?.toString();
                    flowingBHPressure = tab2Input?.intakePressure?.toString();
                    staticBHPressure = tab2Input?.sbhpForPressre?.toString();
                }
                if (inflowType === 2) {
                    flowRate = tab2Input?.flowRateForHd?.toString();
                    flowingBHHd = tab2Input?.prdcngFluidLvl;
                    staticBHHd = tab2Input?.staticFluidLvlForHd?.toString();
                }

                const flowingBHHdUnit = tab2Input?.unitPrdcngFluidLvlListVal;
                const flowRateUnit = tab2Input?.unitFlowRateListVal;
                const flowingBHPressureUnit = tab2Input?.unitIntakePressureListVal;
                const staticBHHdUnit = tab2Input?.unitStaticFluidLvlListVal;
                const staticBHPressureUnit = tab2Input?.unitReservoirPressureListVal;
                const productionRate = tab2Input?.productionRate;
                const productionRateUnit = tab2Input?.unitProductionRateListVal;
                const waterCut = tab3Input?.waterCut;
                const unitSys = tab1Input?.unitSys;
                const perforation = tab2Input?.perforation;
                const perforationUnit = tab2Input?.unitPerforationListVal;
                const gasAvailability = tab3Input?.gasAvailblty;
                const isGasAvailable = gasAvailability && +gasAvailability ? true : false;

                const postData = [bubblePoint, bubblePresUnit, combinedspGr, flowRate, flowRateUnit, flowingBHHd, flowingBHHdUnit, flowingBHPressure, flowingBHPressureUnit, inflowType, piValue, productionRate,
                    productionRateUnit, staticBHHd, staticBHHdUnit, staticBHPressure, staticBHPressureUnit, waterCut, unitSys, perforation, perforationUnit, isGasAvailable, piUnit] as string[];

                // map(data => BasicActions.SET_BASIC_WELL_INFLOW_DATA({ payload: data.inflowData }))
                return from(getIPRTableData(postData)).pipe(
                    map(data => {
                        var ipr = data?.iprSelected;
                        let selection = "";
                        if (ipr === 'Wiggins' || ipr === 'Vogel' || ipr === 'ConstantPI' || ipr === 'Composite')
                            selection = ipr;

                        var result = { data, selection };
                        return result
                    }),
                    mergeMap(result => {
                        return [
                            setBasicWellInflowData(result?.data?.wellInflowData),
                            setBasicIPRMethodologySelection(result?.selection),
                        ]
                    })
                )
            }
            return EMPTY;
        }),
    )
};

const getWellIPRData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("basicCalculation/setBasicWellIPRDepletionPressure"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.basicCalculations?.depletionPressure))
        ),
        switchMap(([actionData, tab1Input, tab2Input, tab3Input, depletionPressure]) => {
            let depletionPercentageObj = {} as DepletionPercentageInObject;
            depletionPercentageObj.inflowType = +(tab2Input?.inflowTypeLstVal || 0);
            depletionPercentageObj.staticBHP = tab2Input?.sbhpForPressre;
            depletionPercentageObj.staticFluidLevel = tab2Input?.staticFluidLvl || 0;
            depletionPercentageObj.compositeSpGr = tab3Input?.combinedSpGr;
            depletionPercentageObj.depletionPressure = depletionPressure;
            depletionPercentageObj.datum = tab2Input?.perforation;//
            depletionPercentageObj.casingPressure = tab2Input?.casingPressure ||0;

            if (depletionPercentageObj.inflowType === 0) {
                depletionPercentageObj.staticBHP = tab2Input?.reservoirPressure;
                depletionPercentageObj.staticFluidLevel = 0;
            }
            else if (depletionPercentageObj.inflowType === 2) {
                depletionPercentageObj.staticFluidLevel = tab2Input?.staticFluidLvlForHd;
            }

            return from(GetDepletionPercentage(depletionPercentageObj)).pipe(
                map(data => {
                    return setBasicWellIPRDepletionPercentage(data)
                }),
            )
        }),
    )
};

const getWellIPRFutureBHP = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("basicCalculation/setBasicWellIPRDepletionPressure", "basicCalculation/setBasicWellIPRFutureProdRate", "basicCalculation/setBasicIPRMethodologySelection"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.basicCalculations?.depletionPressure)),
            state$.pipe(map((state: RootState) => state?.basicCalculations?.futureProductionRate)),
            state$.pipe(map((state: RootState) => state?.basicCalculations?.IPRSelection)),
            state$.pipe(map((state: RootState) => state?.basicCalculations?.wellInflowData)),
        ),
        switchMap(([actionData, tab2Input, tab3Input, depletionPressure, futureProductionRate, selectedIPR, wellInflowData]) => {
            
            if (wellInflowData && wellInflowData[0]) {
                let futureBHPObject = {} as FutureBHPInObject;
                futureBHPObject.inflowType = +(tab2Input?.inflowTypeLstVal || 0);
                futureBHPObject.staticBHP = tab2Input?.sbhpForPressre;
                futureBHPObject.futureShutInPressure = depletionPressure || 0;
                futureBHPObject.futureProductionRate = futureProductionRate || 0;
                futureBHPObject.maxFlowRate = +(wellInflowData[0]?.mxFlowRate4);
                futureBHPObject.combinedSpGr = tab3Input?.combinedSpGr;
                futureBHPObject.perforation = tab2Input?.perforation;

                if (selectedIPR === 'ConstantPI') {
                    futureBHPObject.maxFlowRate = +(wellInflowData[0]?.mxFlowRate3);
                    futureBHPObject.selectedIPR = IPR.ConstantPI;
                    futureBHPObject.PI = +(wellInflowData[0]?.piStrVal3);
                } else if (selectedIPR === 'Composite') {
                    futureBHPObject.maxFlowRate = +(wellInflowData[0]?.mxFlowRate2);
                    futureBHPObject.selectedIPR = IPR.Composite;
                    futureBHPObject.PI = +(wellInflowData[0]?.piStrVal2);
                } else if (selectedIPR === 'Vogel') {
                    futureBHPObject.selectedIPR = IPR.Wiggins; 
                } else if (selectedIPR === 'Wiggins') {
                    futureBHPObject.selectedIPR = IPR.Wiggins;
                }

                if (futureBHPObject.inflowType === 0) {
                    futureBHPObject.staticBHP = tab2Input?.reservoirPressure;
                    futureBHPObject.staticBHHd = tab2Input?.staticFluidLvl;
                }
                else if (futureBHPObject.inflowType === 2) {
                    futureBHPObject.staticBHHd = tab2Input?.staticFluidLvlForHd;
                }

                return from(GetFutureBHP(futureBHPObject)).pipe(
                    map(data => {
                        return setBasicWellIPRFutureBHP(data)
                    }),
                )
            }
            return EMPTY;
        }),
    )
};

const getTdhData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/setGasCalculationComplete"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasFinalCalculatedData)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationComplete)),
        ),
        switchMap(([actionData, tab1Input, tab2Input, tab3Input, basicTdhParameters, gasCalculationOutPut, gasCalculationComplete]) => {
            if (gasCalculationComplete) {
                const casingPressure = +tab2Input?.casingPressure;
                const casingPresUnit = +tab2Input?.unitCasingPressureListVal;
                const prodctnRate = +tab2Input?.productionRate;
                const prodctnRateUnit = +tab2Input?.unitProductionRateListVal;
                const pumpSetng = +tab2Input?.pumpSetting;
                const pumpSetngUnit = +tab2Input?.unitPumpSettingListVal;
                const spGrWatr = +tab3Input?.spGrWater;
                const TVD = +tab2Input?.tvd
                const tubingTyp = +tab1Input?.tubingType;
                const tubingId = +tab1Input?.tubingID;
                const tubingPress = +tab2Input?.tubingPressure
                const tubingPressUnit = +tab2Input?.unitTubingPressureListVal;
                const unitSys = +tab1Input?.unitSys;
                const tubngIDUnit = +tab1Input?.unitTubingIDListVal
                const TVDUnit = +tab2Input?.unitTVDListVal;
                const FLOPUnit = +tab2Input?.unitFLOPListVal;
                let Flop = +basicTdhParameters.FLOP || +tab2Input?.flop;
                let finPIP = +basicTdhParameters.finPIP || +gasCalculationOutPut?.Intake_Pressure;
                const liquidPhaseSpGr = +tab3Input?.liquidPhaseCombinedSpGr;
                const combSpGr = basicTdhParameters?.compSPGr;
                const postdata = [casingPressure, casingPresUnit, prodctnRate, prodctnRateUnit, pumpSetng, pumpSetngUnit, spGrWatr, TVD, tubingTyp, tubingId, tubingPress, tubingPressUnit, unitSys, Flop, combSpGr, finPIP, tubngIDUnit, TVDUnit, FLOPUnit, liquidPhaseSpGr];

                return from(getTDHData(postdata)).pipe(
                    map(tdhData => {
                        var tdhOutput = {} as BasicTDHCalculation;
                        tdhOutput.pipNew = tdhData?.finalPIP?.toString() ?? "";
                        tdhOutput.pip = tdhData?.flop?.toString() ?? "";
                        tdhOutput.tubingHead = tdhData?.tubingHead?.toString() ?? "";
                        tdhOutput.tdh = tdhData?.tdh?.toString() ?? "";
                        tdhOutput.productionLevel = tdhData?.productionLevel?.toString() ?? "";
                        tdhOutput.frictionLoss = tdhData?.frictionLoss?.toString() ?? "";
                        tdhOutput.systemTDH = tdhData?.systemTDH?.toString() ?? "";
                        return tdhOutput
                    }),
                    mergeMap(tdhOutput => {
                        return [
                            setBasicTDHCalculationOutput(tdhOutput),
                            setBasicCalculationComplete(true),
                        ]
                    }),
                )
            }
            return EMPTY;
        })
    )
};

const getNewTdhData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "gasCalculation/setGasCalculationComplete",
            "basicCalculation/setBasicTDHDesiredPIP"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.basicCalculations?.basicTDHCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationComplete)),
        ),
        switchMap(([actionData, tab1Input, tab2Input, tab3Input, tdhCalculation, gasCalculationComplete]) => {

            if (gasCalculationComplete) {
                if (tdhCalculation?.desrdPIP !== '' && tdhCalculation?.desrdPIP !== null && tdhCalculation?.desrdPIP !== undefined && tdhCalculation?.desrdPIP !== 0) {
                    const casngPres = tab2Input?.casingPressure?.toString()
                    const casngPresUnit = tab2Input?.unitCasingPressureListVal
                    const compSPGr = tab3Input?.combinedSpGr.toString()
                    const newPIP = tdhCalculation?.desrdPIP;
                    const prodRate = tab2Input?.productionRate?.toString()
                    const prodRateUnit = tab2Input?.unitProductionRateListVal
                    const pmpSetngMD = tab2Input?.pumpSetting?.toString()
                    const pmpSetngMDUnit = tab2Input?.unitPumpSettingListVal
                    const spGrWatr = tab3Input?.spGrWater?.toString()
                    const tubngAge = tab1Input?.tubingType?.toString()
                    const tubngID = tab1Input?.tubingID?.toString()
                    const tubngPres = tab2Input?.tubingPressure?.toString()
                    const tubngPresUnit = tab2Input?.unitTubingPressureListVal
                    const TVD = tab2Input?.tvd?.toString()
                    const unitSys = tab1Input?.unitSys
                    const tubngIDUnit = tab1Input?.unitTubingIDListVal
                    const TVDUnit = tab2Input?.unitTVDListVal

                    const postDat = [casngPres, casngPresUnit, compSPGr, newPIP, prodRate, prodRateUnit, pmpSetngMD, pmpSetngMDUnit, spGrWatr, tubngAge, tubngID, tubngPres, tubngPresUnit, TVD, unitSys, tubngIDUnit, TVDUnit];

                    return from(CallNewTDH(postDat)).pipe(

                        map(newtdh => {
                            return setBasicNewTDH(newtdh);
                        }),
                    )
                }
                return [setBasicNewTDH('')];
            }
            return EMPTY;
        }),
    )
};

const getIPRPlotData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("basicCalculation/setBasicWellIPRDepletionPercentage"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
        ),
        switchMap(([actionData, tab1Input, tab2Input, tab3Input]) => {

            const bubblePoint = tab3Input?.bubblePoint;
            const bubblePresUnit = tab3Input?.unitBubblePointListVal;
            const combinedspGr = tab3Input?.combinedSpGr;
            const inflowType = +(tab2Input?.inflowTypeLstVal || 0);
            let flowRate = null;
            let flowingBHHd = null;
            let flowingBHPressure = null;
            let piValue = null;
            let staticBHHd = null;
            let staticBHPressure = null;
            const piUnit = tab2Input?.unitPIValListVal;

            if (inflowType === 0) {
                piValue = tab2Input?.piVal?.toString();
                staticBHPressure = tab2Input?.reservoirPressure?.toString();
                staticBHHd = tab2Input?.staticFluidLvl?.toString();
            }
            if (inflowType === 1) {
                flowRate = tab2Input?.flowRate?.toString();
                flowingBHPressure = tab2Input?.intakePressure?.toString();
                staticBHPressure = tab2Input?.sbhpForPressre?.toString();
            }
            if (inflowType === 2) {
                flowRate = tab2Input?.flowRateForHd?.toString();
                flowingBHHd = tab2Input?.prdcngFluidLvl;
                staticBHHd = tab2Input?.staticFluidLvlForHd?.toString();
            }

            const flowingBHHdUnit = tab2Input?.unitPrdcngFluidLvlListVal;
            const flowRateUnit = tab2Input?.unitFlowRateListVal;
            const flowingBHPressureUnit = tab2Input?.unitIntakePressureListVal;
            const staticBHHdUnit = tab2Input?.unitStaticFluidLvlListVal;
            const staticBHPressureUnit = tab2Input?.unitReservoirPressureListVal;
            const productionRate = tab2Input?.productionRate;
            const productionRateUnit = tab2Input?.unitProductionRateListVal;
            const waterCut = tab3Input?.waterCut;
            const unitSys = tab1Input?.unitSys;
            const perforation = tab2Input?.perforation;
            const perforationUnit = tab2Input?.unitPerforationListVal;
            const gasAvailability = tab3Input?.gasAvailblty;
            const isGasAvailable = gasAvailability && +gasAvailability ? true : false;

            const postObj = {
                InflowType: inflowType,
                StaticBHPressure: staticBHPressure,
                StaticBHPressureUnit: staticBHPressureUnit,
                PI: piValue,
                PIUnit: piUnit,
                BubblePtPressure: bubblePoint,
                BubblePtPressureUnit: bubblePresUnit,
                ProductionRate: productionRate,
                ProductionRateUnit: productionRateUnit,
                FlowingBHPressure: flowingBHPressure,
                FlowingBHPressureUnit: flowingBHPressureUnit,
                FlowRate: flowRate,
                FlowRateUnit: flowRateUnit,
                WaterCut: waterCut,
                StaticBHHead: staticBHHd,
                StaticBHHeadUnit: staticBHHdUnit,
                FlowingBHHead: flowingBHHd,
                FlowingBHHeadUnit: flowingBHHdUnit,
                CombinedSpGr: combinedspGr,
                Perforation: perforation,
                PerforationUnit: perforationUnit,
                UnitSystem: unitSys,
                IsGas: isGasAvailable
            }

            return from(getIPRGraphData(postObj))
                .pipe(
                    map(data => {
                        return setIPRChartData(data);
                    })
                )
        }),
    )
};

const getDepletionPlotData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("basicCalculation/setBasicWellIPRDepletionPercentage"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.basicCalculations?.depletionPercentage)),
            state$.pipe(map((state: RootState) => state?.basicCalculations?.wellInflowData)),
        ),
        switchMap(([actionData, tab1Input, tab2Input, tab3Input, depletionPercent, wellInfo]) => {
            const combinedspGr = tab3Input?.combinedSpGr;
            const inflowType = +(tab2Input?.inflowTypeLstVal || 0);
            let flowRate = null;
            let flowingBHHd = null;
            let flowingBHPressure = null;
            let piValue = null;
            let staticBHHd = null;
            let staticBHPressure = null;

            if (inflowType === 0) {
                piValue = tab2Input?.piVal?.toString();
                staticBHPressure = tab2Input?.reservoirPressure?.toString();
                staticBHHd = tab2Input?.staticFluidLvl?.toString();
            }
            if (inflowType === 1) {
                flowRate = tab2Input?.flowRate?.toString();
                flowingBHPressure = tab2Input?.intakePressure?.toString();
                staticBHPressure = tab2Input?.sbhpForPressre?.toString();
            }
            if (inflowType === 2) {
                flowRate = tab2Input?.flowRateForHd?.toString();
                flowingBHHd = tab2Input?.prdcngFluidLvl;
                staticBHHd = tab2Input?.staticFluidLvlForHd?.toString();
            }

            const productionRate = tab2Input?.productionRate;
            const waterCut = tab3Input?.waterCut;
            const unitSys = tab1Input?.unitSys;
            const perforation = tab2Input?.perforation;

            const postObj = {
                InflowType: inflowType,
                StaticBHP: staticBHPressure,
                PI: piValue,
                FlowingBHPressure: flowingBHPressure,
                ProductionRate: productionRate,
                TestFlowRate: flowRate,
                WaterCut: waterCut,
                StaticBHHead: staticBHHd,
                FlowBHHeadFlowBHHead: flowingBHHd,
                CombinedSpGr: combinedspGr,
                Perforation: perforation,
                UnitSystem: unitSys,
                DepletionPercent: depletionPercent,
                VogelMaxFlowRate: +(wellInfo?.[0]?.mxFlowRate2),
                CompositeMaxFlowRate: +(wellInfo?.[0]?.mxFlowRate2)
            }

            return from(getDepletionCurveData(postObj)).pipe(
                map(data => {
                    return setDepletionChartData(data);
                })
            )
        }),
    )
};

export const basicEpic = combineEpics(getWellInflowData, getWellIPRData, getWellIPRFutureBHP, getTdhData, getNewTdhData, getIPRPlotData, getDepletionPlotData);